<template>
	<div class="ppayment">
		<div>	
			<div style="height: .3rem"></div>
			<div class="ppayment-top">
				<h4>选择类型</h4>
				<div>
					<span v-for="(item,index) in typeList" @touchend="getCurrentTyle(index+1)" :class="current==index+1?'on':''">{{item}}</span> 
				</div>
				<h4>选择套餐</h4>
				<div>
					<span v-for="(item,index) in comboList" @touchend="getCurrentCombo(index+1)" :class="comboCurrent==index+1?'on':''">{{item}}</span> 
				</div>
				<p style="height: .25rem;border-bottom: 1px dashed #999;margin: 0 .15rem;"></p>
			</div>
			<div class="ppayment-center">
				<div class="ppayment-banner">
					<img :src="introduceList.imgUrl" alt="图片">
				</div>
				<h4>{{introduceList.packageVal}} —<span>{{introduceList.name}}</span></h4>
				<p>
					{{introduceList.introduce}}
				</p>
			</div>
			<div class="ppayment-bottom">
				<h4>支付方式</h4>
				<div>
					<span class="on">
						支付宝
					</span>
				</div>
			</div>
			<div style="height: 1.3rem"></div>
		</div>
		 <myheader ref="pheader"></myheader> 
		<div class="ppayment-mark">
			<ul>
				<li>
					<span>应付</span>
					<i>¥{{introduceList.price}}</i>
				</li>
				<li>
					<p  @touchend="goPayment">
						立即支付
					</p>
				</li>
			</ul>
		</div>
		<div class="payment-alert" v-show="isPaymentShow">
			<div class='payment-alert-content'>
				<h4>线上支付提示</h4>
				<p>支付完成前，请不要关闭此支付验证窗口</p>
				<p>完成支付后，请根据您的支付的情况点击下面按钮</p>
				<div>
					<span @click='getPaymentSuccess'>支付遇到问题</span>
					<span @click='getPaymentSuccess' class="blue">支付完成</span>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import myheader from "@/phonecomponents/pheader";
	const components = {
		myheader
	}
	export default {
		components: components,
		data() {
			return {
				typeList: ["青年版","中年版","老年版"],
				comboList: ["基础套餐","标准套餐","升级套餐","VIP套餐"],
				isMark: false,
				current: this.$route.query.id,
				comboCurrent: 1,
				myIScroll: null,
				PID:'',
				BID:'',
				username:'',
				isPaymentShow: false,
				introduceList: {
					price: ''
				}
			}
		},
		created() {
			var _this = this;
			setTimeout(function() {
				_this.myIScroll = new IScroll(".ppayment", {
					prevenDefault: true
				})
			})
		},
		methods: {
			getCurrentTyle(ind){
				this.current = ind
				this.getPackageId(ind,this.comboCurrent)
			},
			getCurrentCombo(ind){
				this.comboCurrent = ind
				this.getPackageId(ind,this.current)
			},
			getPackageId(pid,bid){
				this.PID = pid;
				this.BID = bid;
				this.$http.post(urls.urltest + "/personal/getPackagevaBuvInfo.json",{
					pid: pid,
					bid: bid
				})
				.then(function(res){
					this.introduceList = res.body;
				})
			},
			goPayment(){
				if(localStorage.getItem('token')){
					this.$http.post(urls.urltest + "/alipay/checkLogin.json" ,{
						token: localStorage.getItem('token')
					}).then(function(res){
					    window.location.href = urls.urltest +  "/alipay/zfbwappay?pid="+this.PID  + '&bid='+this.BID + '&token=' + localStorage.getItem('token');
						this.isPaymentShow = false;
					})
				}else {
					this.$refs.pheader.goLoginOrReg();
				}
			}
		},//methods
		mounted() {
			this.getPackageId(this.current,this.comboCurrent)
		},
		updated(){
			this.myIScroll.refresh();
		}
	}
</script>
<style lang="scss">
	@import "../styles/core/reset.scss";
	.ppayment{
		width: 100%;
		height: 100%;
		.ppayment-top{
			margin-top: .14rem;
			background: #fff;
			h4{
				font-size: .15rem;
				color: #999999;
				padding: .24rem 0 0 .15rem;
				font-weight: normal;
			}
			div{
				font-size: .18em;
				width: 100%;
				padding-left: .08rem;
				span{
					display: inline-block;
					width: 1.15rem;
					height: .4rem;
					border: 1px solid #E9E9E9;
					box-sizing: border-box;
					margin: .1rem .07rem;
					text-align: center;
					line-height: .4rem;
					&.on{
						border: 1px solid #467DE5;
						box-sizing: border-box;
						font-weight: bold;
						background: url(../assets/Rectangle.png) no-repeat  1.01rem .27rem;
						background-size: .1rem;
					}
				}
			}
		}
		.ppayment-center{
			background: #fff;
			padding: .6rem 0;
			.ppayment-banner{
				margin: 0 .15rem;
				height: 2.26rem;
				border: 1px solid #EEEEEE;
				img{
					display: block;
					width: 100%;
					height: 100%;
				}
			}
			h4{
				font-size: .16rem;
				margin: 0 .15rem;
				padding: .15rem 0;
			}
			p{
				font-size: .16rem;
				margin: 0 .15rem;
				line-height: .4rem;
			}
		}
		.ppayment-bottom{
			background: #fff;
			padding-bottom: .6rem;
			h4{
				font-size: .15rem;
				color: #999999;
				padding: .24rem 0 0 .15rem;
				font-weight: normal;
			}
			div{
				font-size: .16rem;
				width: 100%;
				padding-left: .08rem;
				span{
					display: inline-block;
					width: 1.15rem;
					height: .4rem;
					border: 1px solid #E9E9E9;
					box-sizing: border-box;
					margin: .1rem .07rem;
					text-align: center;
					line-height: .4rem;
					&.on{
						border: 1px solid #467DE5;
						box-sizing: border-box;
						font-weight: bold;
						background: url(../assets/Rectangle.png) no-repeat  1.01rem .27rem;
						background-size: .1rem;
					}
				}
			}
		}
		.ppayment-mark{
			width: 100%;
			height: .6rem;
			background: rgba(255,255,255,.9);
			position: absolute;
			bottom: .57rem;
			left: 0;
			box-shadow: 0 9px 20px 0;
			font-size: .16rem;
			ul{
				width: 100%;
				height: 100%;
				@include flexbox;
				justify-content: space-between;
				align-items: center;
				span{
					padding-left: .15rem;
				}
				i{
					color: red;
					padding-left: .1rem;
				}
				p{
					width: 1.35rem;
					height: .4rem;
					color: #fff;
					background: #467DE5;
					text-align: center;
					line-height: .4rem;
					margin-right: .15rem;
				}
			}
		}
		.payment-alert{
			width: 100%;
			height: 100%;
			background: rgba(0,0,0,0.7);
			position: absolute;
			top: 0;
			left: 0;
			z-index: 9991;
			.payment-alert-content{
				width: 3.45rem;
				height: 4.67rem;
				position: absolute;
				top: 50%;
				left: 50%;
				transform: translate(-50%, -50%);
				background: #fff;
				border-radius: .05rem;
				overflow: hidden;
				h4{
					height: .6rem;
					line-height: .6rem;
					font-size: .18rem;
					text-align: center;
					color: #555555;
					border-bottom: 1px solid #eee;
					margin-bottom: 1.2rem;
				}
				p{
					font-size: .14rem;
					padding-top: .1rem;
					padding-left: .1rem;
				}
				div{
					font-size: .18rem;
					width: 100%;
					height: .5rem;
					@include flexbox;
					line-height: .5rem;
					text-align: center;
					position: absolute;
					left: 0;
					bottom: 0;
					span{
						@include flex;
						height: 100%;
						color: #fff;
						background: #bbb;
						&.blue{
							background: #467DE5;
						}
					}
				}
			}
		}
	}
</style>


// WEBPACK FOOTER //
// payment.vue?40a23fe4